
"use strict";
(function () {
  var CFG = window.LQ_CONFIG || {};
  var ROUTES = CFG.routes || {};
  var LQ = (window.LQ = window.LQ || {});


  LQ.FREE_THRESHOLD = (typeof CFG.freeThreshold === "number" && CFG.freeThreshold > 0)
    ? CFG.freeThreshold : null;


  var MONEY_FMT = (function () {
    var f = CFG.moneyFormat || "";
    var m = f.match(/^([^{]*)\{\{[^}]*\}\}([^{]*)$/);
    return m ? { pre: m[1], post: m[2] } : { pre: "R", post: "" };
  })();
  LQ.money = function (cents) {
    var n = Math.round((cents || 0) / 100);
    return MONEY_FMT.pre + n.toLocaleString("en-ZA") + MONEY_FMT.post;
  };
  LQ.moneyExact = function (cents) {
    var n = (cents || 0) / 100;
    return MONEY_FMT.pre + n.toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + MONEY_FMT.post;
  };

  function j(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(r.status + " " + t); });
      return r.json();
    });
  }
  function post(url, body) {
    return j(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    });
  }

  /* ============================================================
     CART
     ============================================================ */
  var Cart = (LQ.Cart = {
    state: null,
    get: function () {
      return j(ROUTES.cart + ".js").then(function (c) { Cart.state = c; return c; });
    },
    add: function (variantId, qty, opts) {
      opts = opts || {};
      if (!variantId) {
        console.error("[LQ.Cart.add] no variant id: check the data-add-to-cart contract (spine S4)");
        return Promise.reject(new Error("no variant id"));
      }
      return post(ROUTES.cartAdd + ".js", { items: [{ id: Number(variantId), quantity: qty || 1 }] })
        .then(function () { return Cart.refresh(); })
        .then(function (cart) {
          if (!opts.silent) {
            pulseBadge();
            LQ.Toast.show((opts.name || "Item") + " added to your cart", "check");
            LQ.Drawer.open();
          }
          return cart;
        })
        .catch(function (e) {
          LQ.Toast.show("Sorry, that could not be added to your cart.", "close");
          throw e;
        });
    },
    change: function (key, qty) {
      return post(ROUTES.cartChange + ".js", { id: key, quantity: qty }).then(function (c) {
        Cart.state = c;
        renderBadge(c);
        renderMini(c);
        if (window.renderCartPage) window.renderCartPage(c);
        return c;
      });
    },
    refresh: function () {
      return Cart.get().then(function (c) {
        renderBadge(c);
        renderMini(c);
        if (window.renderCartPage) window.renderCartPage(c);
        return c;
      });
    },

    note: function (note) {
      return post(ROUTES.cartUpdate + '.js', { note: note }).then(function (c) {
        Cart.state = c;
        return c;
      });
    },

    // Needs province too: this store's zones reject a zip-only lookup with a 422.
    shippingRates: function (zip, province) {
      zip = (zip || '').trim();
      province = (province || '').trim();
      if (!zip || !province) return Promise.reject(new Error('postal code and province required'));
      var qs = 'shipping_address[zip]=' + encodeURIComponent(zip) +
               '&shipping_address[country]=' + encodeURIComponent('South Africa') +
               '&shipping_address[province]=' + encodeURIComponent(province);
      return j(ROUTES.cart + '/shipping_rates.json?' + qs).then(function (data) {
        return (data && data.shipping_rates) || [];
      });
    }
  });

  function renderBadge(cart) {
    var n = cart ? cart.item_count : 0;
    document.querySelectorAll(".cart-count").forEach(function (b) {
      b.textContent = n;
      b.style.display = n ? "grid" : "none";
    });
  }
  function pulseBadge() {
    document.querySelectorAll(".cart-count").forEach(function (b) {
      b.classList.remove("pulse");
      void b.offsetWidth;
      b.classList.add("pulse");
    });
  }

  function renderMini(cart) {
    var wrap = document.getElementById("miniBody");
    var foot = document.getElementById("miniFoot");
    var fb = document.getElementById("freeBar");
    if (!wrap || !cart) return;

    if (!cart.items.length) {
      wrap.innerHTML =
        '<div class="mini-empty"><p>Your cart is empty.</p>' +
        '<a class="btn btn-ghost btn-sm" href="' + esc(ROUTES.allProducts || "/collections/all") + '">Start shopping</a></div>';
      if (foot) foot.style.display = "none";
      if (fb) fb.style.display = "none";
      return;
    }

    wrap.innerHTML = cart.items.map(function (l) {
      var img = l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : "";
      var was = l.original_line_price > l.final_line_price
        ? '<span class="was">' + LQ.moneyExact(l.original_line_price) + "</span>" : "";
      return (
        '<div class="mini-line">' +
          '<span class="ph"><img src="' + esc(img) + '" alt="" loading="lazy"></span>' +
          '<div class="info">' +
            '<div class="nm">' + esc(l.product_title) + "</div>" +
            '<div class="pr">' + LQ.moneyExact(l.final_line_price) + was + "</div>" +
            '<div class="qty">' +
              '<button onclick="LQ.Cart.change(\'' + l.key + "'," + (l.quantity - 1) + ')" aria-label="Decrease">&minus;</button>' +
              "<span>" + l.quantity + "</span>" +
              '<button onclick="LQ.Cart.change(\'' + l.key + "'," + (l.quantity + 1) + ')" aria-label="Increase">+</button>' +
            "</div>" +
          "</div>" +
          '<button class="rm" onclick="LQ.Cart.change(\'' + l.key + '\',0)">Remove</button>' +
        "</div>"
      );
    }).join("");

    var totRand = cart.total_price / 100;

    var FREE_DELIVERY_WEIGHT_LIMIT_G = 30000;
    var overWeightLimit = cart.total_weight >= FREE_DELIVERY_WEIGHT_LIMIT_G;

    if (fb && LQ.FREE_THRESHOLD === null) fb.style.display = "none";
    var remain = LQ.FREE_THRESHOLD === null ? 0 : Math.max(0, LQ.FREE_THRESHOLD - totRand);
    if (fb && LQ.FREE_THRESHOLD !== null) {
      fb.style.display = "block";
      var pct = Math.min(100, (totRand / LQ.FREE_THRESHOLD) * 100);
      fb.innerHTML = overWeightLimit
        ? "Standard delivery rates apply over <b>30kg</b>" +
          '<div class="track"><div class="fill" style="width:' + pct + '%"></div></div>'
        : remain > 0
        ? "Add <b>R" + Math.ceil(remain).toLocaleString("en-ZA") + "</b> more for <b>FREE delivery</b>" +
          '<div class="track"><div class="fill" style="width:' + pct + '%"></div></div>'
        : "You&rsquo;ve unlocked <b>FREE delivery</b>" +
          '<div class="track"><div class="fill" style="width:100%"></div></div>';
    }

    if (foot) {
      foot.style.display = "block";
      var saved = cart.original_total_price - cart.total_price;
      var quarter = Math.round(cart.total_price / 4);

      var totalWeightKg = Math.round(cart.total_weight / 10) / 100;
      var weightRow = cart.total_weight > 0
        ? '<div class="row"><span>Total weight</span><b>' + totalWeightKg + " kg</b></div>"
        : "";
      foot.innerHTML =
        '<div class="row"><span>Subtotal</span><b>' + LQ.moneyExact(cart.total_price) + "</b></div>" +
        weightRow +
        (saved > 0 ? '<div class="row"><span>You save</span><b style="color:var(--green)">&minus;' + LQ.moneyExact(saved) + "</b></div>" : "") +
        '<div class="row tot"><span>Total</span><b>' + LQ.moneyExact(cart.total_price) + "</b></div>" +
        '<div class="bnpl">or 4&times; ' + LQ.moneyExact(quarter) + " interest-free with Payflex</div>" +
        '<form action="' + ROUTES.cart + '" method="post"><button type="submit" name="checkout" class="btn btn-amber btn-block">Secure checkout</button></form>' +
        '<a class="btn btn-ghost btn-block" href="' + ROUTES.cart + '" style="margin-top:8px">View cart</a>';
    }
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (m) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m];
    });
  }
  LQ._esc = esc;

  function scrim(show) {
    var s = document.getElementById("scrim");
    if (s) s.classList.toggle("show", !!show);
    document.body.style.overflow = show ? "hidden" : "";
  }
  LQ._scrim = scrim;

  function panel(id) {
    return {
      open: function () {
        var d = document.getElementById(id); if (!d) return;
        setInert(d, false);
        d.classList.add("open");
        scrim(true);
        var f = d.querySelector(FOCUSABLE); if (f) f.focus();
      },
      close: function () {
        var d = document.getElementById(id); if (!d) return;
        d.classList.remove("open");
        setInert(d, true);
        scrim(false);
      }
    };
  }
  LQ.Drawer = panel("miniCart");
  LQ.Nav = panel("mnav");

  var SUGG = ["Whisky", "Red wine", "Gin", "Champagne", "Craft beer", "Tequila"];
  var searchTimer = null;
  LQ.Search = {
    open: function (q) {
      var p = document.getElementById("searchPanel");
      if (!p) return;
      p.classList.add("open");
      document.body.style.overflow = "hidden";
      var input = document.getElementById("spInput");
      if (input) { if (q != null) input.value = q; input.focus(); }
      LQ.Search.run(q || "");
    },
    close: function () {
      var p = document.getElementById("searchPanel");
      if (p) p.classList.remove("open");
      document.body.style.overflow = "";
    },
    run: function (q) {
      var body = document.getElementById("spBody");
      if (!body) return;
      q = (q || "").trim();
      /* empty state = the concept's "Popular searches" chips, same markup */
      if (!q) {
        body.innerHTML =
          '<div class="sp-sect">Popular searches</div><div class="sp-sugg">' +
          SUGG.map(function (t) {
            return '<button onclick="LQ.openSearch(' + JSON.stringify(t).replace(/"/g, "&quot;") + ')">' + esc(t) + "</button>";
          }).join("") + "</div>";
        return;
      }
      clearTimeout(searchTimer);
      searchTimer = setTimeout(function () {
        var suggestUrl = (ROUTES.predictive || "/search/suggest") +
          ".json?q=" + encodeURIComponent(q) +
          "&resources[type]=product&resources[limit]=8";

        var countUrl = "/search?view=count&q=" + encodeURIComponent(q) + "&type=product";
        Promise.all([
          j(suggestUrl),
          fetch(countUrl)
            .then(function (r) { return r.ok ? r.text() : null; })
            .catch(function () { return null; })
        ])
          .then(function (res) {
            var r = res[0];
            var countText = res[1];
            var list = ((r.resources || {}).results || {}).products || [];
            if (!list.length) {
              body.innerHTML = '<div class="sp-empty">No matches for &ldquo;' + esc(q) +
                '&rdquo;. Try a brand, type, or &ldquo;whisky under R400&rdquo;.</div>';
              return;
            }
            /* Fall back to list.length (what we actually got back) if the count request
               failed, was blocked, or returned something unparsable - the dropdown must never
               show a blank or nonsensical number just because the extra request had trouble. */
            var total = countText == null ? NaN : parseInt(countText, 10);
            var shownCount = (!isNaN(total) && total > 0) ? total : list.length;
            body.innerHTML =
              '<div class="sp-sect">' + shownCount + " result" + (shownCount > 1 ? "s" : "") + "</div>" +
              '<div class="sp-res">' +
              list.map(function (p) {
                var sub = [p.vendor, (p.product_type || "")].filter(Boolean).join(" \u00b7 ");
                return '<a href="' + esc(p.url) + '">' +
                  '<span class="ph"><img src="' + esc(p.featured_image ? p.featured_image.url : "") + '" alt="" loading="lazy"></span>' +
                  '<span class="nm">' + esc(p.title) + "<small>" + esc(sub) + "</small></span>" +
                  '<span class="pr">' + LQ.moneyExact(Math.round(parseFloat(p.price) * 100)) + "</span></a>";
              }).join("") + "</div>";
          })
          .catch(function () {
            body.innerHTML = '<div class="sp-empty">Search is unavailable right now.</div>';
          });
      }, 180);
    }
  };

  /* ============================================================
     TOAST
     ============================================================ */
  LQ.Toast = {
    show: function (msg, iconKey) {
      var host = document.getElementById("toastHost");
      if (!host) return;
      var t = document.createElement("div");
      t.className = "toast";
      t.setAttribute("role", "status");
      t.innerHTML = '<span class="t-ico" data-i="' + (iconKey || "check") + '"></span><span>' + esc(msg) + "</span>";
      host.appendChild(t);
      requestAnimationFrame(function () { t.classList.add("in"); });
      setTimeout(function () {
        t.classList.remove("in");
        setTimeout(function () { t.remove(); }, 260);
      }, 3200);
    }
  };

  /* ============================================================
     WISHLIST (localStorage, same key as the concept)
     ============================================================ */
  LQ.Wish = {
    list: function () { try { return JSON.parse(localStorage.getItem("liq_wish") || "[]"); } catch (e) { return []; } },
    toggle: function (id, btn) {
      var w = LQ.Wish.list();
      var on = w.indexOf(String(id)) > -1;
      w = on ? w.filter(function (x) { return x !== String(id); }) : w.concat(String(id));
      localStorage.setItem("liq_wish", JSON.stringify(w));
      if (btn) btn.classList.toggle("on", !on);
      LQ.Toast.show(on ? "Removed from wishlist" : "Saved to your wishlist", "heart");
      renderWishBadge();
      pulseWishBadge();
      return !on;
    },
    paint: function (root) {
      var w = LQ.Wish.list();
      (root || document).querySelectorAll("[data-wish]").forEach(function (b) {
        b.classList.toggle("on", w.indexOf(String(b.getAttribute("data-wish"))) > -1);
      });
      renderWishBadge();
    }
  };

  function renderWishBadge() {
    var n = LQ.Wish.list().length;
    document.querySelectorAll(".wish-count").forEach(function (b) {
      b.textContent = n;
      b.style.display = n ? "grid" : "none";
    });
  }
  function pulseWishBadge() {
    document.querySelectorAll(".wish-count").forEach(function (b) {
      b.classList.remove("pulse");
      void b.offsetWidth;
      b.classList.add("pulse");
    });
  }

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),' +
                  'textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  var scrollLocks = 0;
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1));
    document.documentElement.style.overflow = scrollLocks ? "hidden" : "";
    document.body.style.overflow = scrollLocks ? "hidden" : "";
  }

  function trapFocus(el) {
    var prev = document.activeElement;
    function items() {
      return [].slice.call(el.querySelectorAll(FOCUSABLE))
               .filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
    }
    function onKey(e) {
      if (e.key !== "Tab") return;
      var f = items();
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !el.contains(document.activeElement))) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
    el.addEventListener("keydown", onKey);
    document.addEventListener("keydown", function guard(e) {

      if (e.key === "Tab" && !el.contains(document.activeElement)) {
        var f = items(); if (f.length) { e.preventDefault(); f[0].focus(); }
      }
      if (!document.body.contains(el)) document.removeEventListener("keydown", guard);
    });
    var f = items();
    if (f.length) f[0].focus(); else { el.setAttribute("tabindex", "-1"); el.focus(); }
    return function release() {
      el.removeEventListener("keydown", onKey);
      if (prev && document.body.contains(prev)) { try { prev.focus(); } catch (e) {} }
    };
  }


  function setInert(el, on) {
    if (!el) return;
    var native = "inert" in HTMLElement.prototype;
    if (native) el.inert = !!on;

    if (on && !native) el.setAttribute("aria-hidden", "true");
    else el.removeAttribute("aria-hidden");
  }
  LQ._setInert = setInert;
  LQ._trapFocus = trapFocus;
  LQ._lockScroll = lockScroll;

  var AGE_COOKIE = "liq_age";
  var AGE_COOKIE_DAYS = 30;
  var AGE_REDIRECT_URL = "https://www.google.com";
  var AGE_REDIRECT_DELAY_MS = 6000; 

  function getCookie(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + expires + "; path=/; SameSite=Lax";
  }

  var ageRelease = null;
  var ageRedirectTimer = null;
  var ageFormBound = false;

  /* DOB -> Date, rejecting anything the three selects could produce that isn't a real
     calendar date (e.g. 31 February rolls over in plain JS Date math instead of erroring). */
  function parseDob(day, month, year) {
    day = parseInt(day, 10);
    month = parseInt(month, 10);
    year = parseInt(year, 10);
    if (!day || !month || !year) return null;
    var d = new Date(year, month - 1, day);
    if (d.getFullYear() !== year || d.getMonth() !== month - 1 || d.getDate() !== day) return null;
    return d;
  }
  function isAdult(dob) {
    var today = new Date();
    var age = today.getFullYear() - dob.getFullYear();
    var hadBirthdayThisYear =
      today.getMonth() > dob.getMonth() ||
      (today.getMonth() === dob.getMonth() && today.getDate() >= dob.getDate());
    if (!hadBirthdayThisYear) age--;
    return age >= 18;
  }
  function initAgeForm() {
    if (ageFormBound) return;
    ageFormBound = true;
    var form = document.getElementById("ageForm");
    if (!form) return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var day = document.getElementById("ageDay").value;
      var month = document.getElementById("ageMonth").value;
      var year = document.getElementById("ageYear").value;
      var err = document.getElementById("ageDobError");
      var dob = parseDob(day, month, year);
      if (!dob) {
        if (err) { err.hidden = false; }
        return;
      }
      if (err) err.hidden = true;
      if (isAdult(dob)) LQ.ageOk();
      else LQ.ageNo();
    });
  }

  function ageGate() {
    var g = document.getElementById("ageGate");
    if (!g) return;
    if (getCookie(AGE_COOKIE) === "ok") { g.remove(); return; }
    g.hidden = false;
    g.classList.add("show");
    lockScroll(true);
    initAgeForm();

    ageRelease = trapFocus(g);
  }
  function ageDismiss() {
    var g = document.getElementById("ageGate");
    clearTimeout(ageRedirectTimer);
    if (ageRelease) { ageRelease(); ageRelease = null; }
    if (g) g.remove();
    lockScroll(false);
  }
  LQ.ageOk = function () {
    setCookie(AGE_COOKIE, "ok", AGE_COOKIE_DAYS);
    ageDismiss();
    
    var m = document.getElementById("main");
    if (m) { m.setAttribute("tabindex", "-1"); m.focus(); }
  };
  LQ.ageNo = function () {
    var d = document.getElementById("ageDeny");
    if (d) { d.style.display = "block"; d.setAttribute("role", "alert"); }
    var a = document.querySelector("#ageGate .age-actions");
    if (a) a.style.display = "none";

    var back = document.getElementById("ageBack");
    if (back) { back.hidden = false; back.focus(); }
    clearTimeout(ageRedirectTimer);
    ageRedirectTimer = setTimeout(function () {
      window.location.href = AGE_REDIRECT_URL;
    }, AGE_REDIRECT_DELAY_MS);
  };
  LQ.ageBack = function () {
    clearTimeout(ageRedirectTimer);
    var d = document.getElementById("ageDeny");
    if (d) d.style.display = "none";
    var a = document.querySelector("#ageGate .age-actions");
    if (a) a.style.display = "";
    var back = document.getElementById("ageBack");
    if (back) back.hidden = true;
    var yes = document.querySelector("#ageGate .age-actions button");
    if (yes) yes.focus();
  };

  function offerModal() {
    var o = document.getElementById("offerPop");
    if (!o) return;
    if (localStorage.getItem("liq_offer") === "seen") { o.remove(); return; }
    var fired = false;
    /* don't interrupt an active task: defer while cart / nav / search / filters / chat are open */
    function busy() {
      return document.querySelector("#miniCart.open,#mnav.open,#searchPanel.open,#filters.open,#chatWin.open,#ageGate.show");
    }

    function show() {
      if (fired || localStorage.getItem("liq_offer") === "seen") return;
      if (busy()) { setTimeout(show, 4000); return; }
      fired = true;
      o.hidden = false;
      o.classList.add("open");
      offerRelease = trapFocus(o);
      lockScroll(true);
    }
    setTimeout(show, 9000);
    document.addEventListener("mouseout", function (e) {
      if (!e.relatedTarget && e.clientY <= 0) show();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && o.classList.contains("open")) LQ.closeOffer();
    });
  }
  var offerRelease = null;
  LQ.closeOffer = function () {
    var o = document.getElementById("offerPop");

    var wasVisible = o && o.classList.contains("open");
    if (wasVisible) localStorage.setItem("liq_offer", "seen");
    if (!o) return;
    if (offerRelease) { offerRelease(); offerRelease = null; }
    o.classList.remove("open");
    if (wasVisible) lockScroll(false);
    setTimeout(function () { o.remove(); }, 300);
  };
  LQ.claimOffer = function (ev) {

    localStorage.setItem("liq_offer", "seen");
    if (ev && ev.target) return true;
  };


  function stickyState() {
    var h = document.querySelector("header.site");
    if (!h) return;
    var on = false;
    addEventListener("scroll", function () {
      var y = window.scrollY || window.pageYOffset;
      var want = y > 8;
      if (want !== on) { on = want; h.classList.toggle("stuck", on); }
    }, { passive: true });
  }

  LQ.footAcc = function (el) {
    var open = el.getAttribute("aria-expanded") === "true";
    el.setAttribute("aria-expanded", open ? "false" : "true");
    var col = el.closest(".foot-col");
    if (col) col.classList.toggle("open", !open);
  };


  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-add-to-cart],[data-variant-id]");
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute("data-add-to-cart") || btn.getAttribute("data-variant-id") || btn.getAttribute("data-product-id");
    if (!id) { console.error("[add-to-cart] control has no id attribute (spine S4)", btn); return; }
    if (btn.dataset.busy === "1") return;
    btn.dataset.busy = "1";
    var was = btn.innerHTML;
    btn.classList.add("is-loading");

    var qtyField = (btn.closest("form") && btn.closest("form").querySelector('[name="quantity"]'))
      || (btn.id === "stickyAdd" ? document.getElementById("qtyV") : null);
    var qty = qtyField ? (parseInt(qtyField.value, 10) || 1) : Number(btn.getAttribute("data-qty") || 1);
    LQ.Cart.add(id, qty, { name: btn.getAttribute("data-name") || "Item" })
      .then(function () {
        btn.classList.remove("is-loading");
        btn.classList.add("is-added");
        btn.innerHTML = "Added";
        setTimeout(function () { btn.innerHTML = was; btn.classList.remove("is-added"); btn.dataset.busy = "0"; }, 1400);
      })
      .catch(function () {
        btn.classList.remove("is-loading");
        btn.innerHTML = was;
        btn.dataset.busy = "0";
      });
  });

  /* wishlist delegation */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-wish]");
    if (!b) return;
    e.preventDefault();
    LQ.Wish.toggle(b.getAttribute("data-wish"), b);
  });


  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (document.querySelector("#searchPanel.open")) return LQ.Search.close();
    if (document.querySelector("#miniCart.open")) return LQ.Drawer.close();
    if (document.querySelector("#mnav.open")) return LQ.Nav.close();
    if (document.querySelector("#chatWin.open") && LQ.closeChat) return LQ.closeChat();
    if (document.querySelector("#filters.open") && LQ.PLP) return LQ.PLP.closeFilters();
  });


  var PLP = (LQ.PLP = {});
  var filtersEl = null;
  var plpRelease = null;

  var MOBILE_Q = window.matchMedia ? window.matchMedia("(max-width: 900px)") : null;
  function railIsDrawer() { return MOBILE_Q ? MOBILE_Q.matches : window.innerWidth <= 900; }

  function syncRailInert() {
    if (!filtersEl) return;
    var closed = !filtersEl.classList.contains("open");
    setInert(filtersEl, railIsDrawer() && closed);
  }

  PLP.openFilters = function () {
    if (!filtersEl) return;
    filtersEl.classList.add("open");
    var sc = document.getElementById("plpScrim");
    if (sc) sc.classList.add("show");
    setInert(filtersEl, false);
    var t = document.querySelector('[data-filters-open]');
    if (t) t.setAttribute("aria-expanded", "true");
    if (railIsDrawer()) {
      lockScroll(true);
      plpRelease = trapFocus(filtersEl);
    }
  };
  PLP.closeFilters = function () {
    if (!filtersEl) return;
    filtersEl.classList.remove("open");
    var sc = document.getElementById("plpScrim");
    if (sc) sc.classList.remove("show");
    if (plpRelease) { plpRelease(); plpRelease = null; }
    lockScroll(false);
    var t = document.querySelector('[data-filters-open]');
    if (t) { t.setAttribute("aria-expanded", "false"); try { t.focus(); } catch (e) {} }
    syncRailInert();
  };

  function initPLP() {
    filtersEl = document.getElementById("filters");
    var form = document.getElementById("filterForm");
    var sortForm = document.getElementById("sortForm");

    var sortSel = document.getElementById("sortSel");
    if (sortSel && sortForm) {
      sortSel.addEventListener("change", function () { sortForm.submit(); });
    }

    if (!filtersEl) return;

    var acc = document.getElementById("filterAcc");
    if (acc) {
      acc.addEventListener("click", function (e) {
        var h = e.target.closest("[data-acc-toggle]");
        if (!h) return;
        var sec = h.closest(".acc");
        if (!sec) return;
        var open = sec.classList.toggle("open");
        h.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }

    if (form) {
      form.addEventListener("change", function (e) {
        if (railIsDrawer()) return;
        if (e.target && e.target.type === "number") return;   // let them finish typing a price
        form.submit();
      });
    }

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-filters-open]")) { e.preventDefault(); PLP.openFilters(); }
      else if (e.target.closest("[data-filters-close]")) { e.preventDefault(); PLP.closeFilters(); }
    });

    if (MOBILE_Q) {
      var onBP = function () { if (!railIsDrawer()) PLP.closeFilters(); else syncRailInert(); };
      if (MOBILE_Q.addEventListener) MOBILE_Q.addEventListener("change", onBP);
      else if (MOBILE_Q.addListener) MOBILE_Q.addListener(onBP);
    }

    syncRailInert();
  }

  function initCase() {
    var panel = document.getElementById('casePanel');
    if (!panel) return;
    var target = 6;
    var items = [];                                    // [{id, name, price, q}]

    var elFill = document.getElementById('cpFill');
    var elProg = document.getElementById('cpProg');
    var elSlots = document.getElementById('cpSlots');
    var elLines = document.getElementById('cpLines');
    var elSub = document.getElementById('cpSub');
    var elHint = document.getElementById('cpHint');
    var elTrust = document.getElementById('cpTrustTxt');
    var elAdd = document.getElementById('cpAdd');

    function count() { return items.reduce(function (n, l) { return n + l.q; }, 0); }
    function subtotal() { return items.reduce(function (s, l) { return s + l.price * l.q; }, 0); }

    function ico(id) {
      var t = document.getElementById(id);
      var node = t && t.content && t.content.firstElementChild;
      return node ? node.cloneNode(true) : null;
    }

    function renderSlots() {
      if (!elSlots) return;
      var flat = [];
      items.forEach(function (l) { for (var k = 0; k < l.q; k++) flat.push(l.img || ''); });
      elSlots.textContent = '';
      for (var i = 0; i < target; i++) {
        var slot = document.createElement('span');
        if (flat[i]) {
          slot.className = 'cp-slot full';
          var im = document.createElement('img');
          im.src = flat[i]; im.alt = '';
          slot.appendChild(im);
        } else {
          slot.className = 'cp-slot';
          var g = ico('cpIcoPlus');
          if (g) slot.appendChild(g);
        }
        elSlots.appendChild(slot);
      }

      var over = flat.length - target;
      if (over > 0) {
        var more = document.createElement('span');
        more.className = 'cp-slot more';
        more.textContent = '+' + over;
        elSlots.appendChild(more);
      }
    }

    function renderLines() {
      if (!elLines) return;
      elLines.textContent = '';
      if (!items.length) {
        var empty = document.createElement('div');
        empty.className = 'cp-empty';
        var cart = ico('cpIcoCart');
        if (cart) empty.appendChild(cart);
        var msg = document.createElement('p');
        msg.textContent = 'Your case is empty. Add bottles from the left to start mixing.';
        empty.appendChild(msg);
        elLines.appendChild(empty);
        return;
      }
      items.forEach(function (l) {
        var row = document.createElement('div');
        row.className = 'cp-line';

        var ph = document.createElement('span');
        ph.className = 'ph';
        if (l.img) {
          var im = document.createElement('img');
          im.src = l.img; im.alt = ''; im.loading = 'lazy'; im.decoding = 'async';
          ph.appendChild(im);
        }

        var info = document.createElement('div');
        info.className = 'cp-info';
        var nm = document.createElement('div');
        nm.className = 'nm';
        nm.textContent = l.name;                       // textContent: never innerHTML with a product title
        var pr = document.createElement('div');
        pr.className = 'pr';
        pr.textContent = LQ.money(l.price);            // the UNIT price, like the oracle: the stepper carries the quantity
        info.appendChild(nm); info.appendChild(pr);

        var q = document.createElement('div');
        q.className = 'cp-q';
        var less = document.createElement('button');
        less.type = 'button';
        less.setAttribute('aria-label', 'Remove one ' + l.name);
        less.textContent = '\u2212';
        less.addEventListener('click', function () {
          l.q--;
          if (l.q <= 0) items = items.filter(function (x) { return x.id !== l.id; });
          render();
        });
        var qty = document.createElement('span');
        qty.textContent = l.q;
        var plus = document.createElement('button');
        plus.type = 'button';
        plus.setAttribute('aria-label', 'Add one ' + l.name);
        plus.textContent = '+';
        plus.addEventListener('click', function () { l.q++; render(); });
        q.appendChild(less); q.appendChild(qty); q.appendChild(plus);

        row.appendChild(ph); row.appendChild(info); row.appendChild(q);
        elLines.appendChild(row);
      });
    }

    /* Literal strings and derived integers only. No product data reaches this markup, which is
       why it may be assembled as HTML at all; everything that touches a title goes through
       textContent above. */
    function progressHTML(c) {
      if (c === 0) return 'Add <b>' + target + '</b> bottles to build your case';
      if (c < 6) return '<b>' + c + '</b> in your case &middot; add <b>' + (6 - c) + '</b> more to unlock <b>5% off</b>';
      if (c < 12) return '<b>' + c + '</b> bottles &middot; <b>5% off</b> unlocked &middot; add <b>' + (12 - c) + '</b> more for <b>10% off</b>';
      return '<b>' + c + '</b> bottles &middot; maximum <b>10% off</b> unlocked';
    }

    function render() {
      var c = count();
      var pct = Math.min(100, Math.round((c / target) * 100));
      if (elFill) elFill.style.width = pct + '%';
      if (elProg) elProg.innerHTML = progressHTML(c);
      if (elSub) elSub.textContent = LQ.money(subtotal());
      if (elAdd) elAdd.disabled = c === 0;
      if (elHint) {

        elHint.hidden = c >= 6;
        if (c < 6) elHint.textContent = 'Add ' + (6 - c) + ' more to unlock 5% off your case.';
      }
      if (elTrust && LQ.FREE_THRESHOLD !== null) {

        var short = LQ.FREE_THRESHOLD - subtotal() / 100;
        elTrust.innerHTML = short <= 0
          ? 'Your case ships <b>free</b>, nationwide.'
          : 'Add <b>' + LQ.money(Math.round(short * 100)) + '</b> more for free delivery.';
      }
      renderSlots();
      renderLines();
      renderCross();
    }

    function renderCross() {
      var box = document.getElementById('cpCross');
      if (!box) return;
      var rows = box.querySelectorAll('[data-cross-row]');
      var chosen = null;
      for (var i = 0; i < rows.length; i++) {
        var id = rows[i].getAttribute('data-cross-id');
        var held = items.filter(function (x) { return x.id === id; }).length > 0;
        if (!held && !chosen) chosen = rows[i];
        rows[i].hidden = true;
      }
      if (chosen) chosen.hidden = false;
      box.hidden = !chosen;
    }

    panel.querySelectorAll('[data-case-target]').forEach(function (b) {
      b.addEventListener('click', function () {
        target = parseInt(b.getAttribute('data-case-target'), 10) || 6;
        panel.querySelectorAll('[data-case-target]').forEach(function (x) { x.classList.toggle('on', x === b); });
        render();
      });
    });

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-case-add]');
      if (!b) return;
      e.preventDefault();
      var id = b.getAttribute('data-case-add');
      var line = items.filter(function (x) { return x.id === id; })[0];
      if (line) line.q++;
      else items.push({
        id: id,
        name: b.getAttribute('data-case-name'),
        price: Number(b.getAttribute('data-case-price')) || 0,
        img: b.getAttribute('data-case-img') || '',
        q: 1,
      });
      render();
    });

    var clear = document.getElementById('cpClear');
    if (clear) clear.addEventListener('click', function () { items = []; render(); });

    if (elAdd) {
      elAdd.addEventListener('click', function () {
        if (!items.length) return;
        elAdd.disabled = true;
        elAdd.classList.add('is-loading');
        /* One /cart/add.js call with every line: fewer requests, and it either all lands or
           none does, so the case can never be half-added. */
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items.map(function (l) { return { id: Number(l.id), quantity: l.q }; }) }),
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed ' + r.status);
          return Cart.refresh();
        }).then(function () {
          LQ.Toast.show('Case of ' + count() + ' added to your cart', 'check');
          items = [];
          render();
        }).catch(function () {
          LQ.Toast.show('Could not add the case. Please try again', 'cart');
        }).then(function () {
          elAdd.classList.remove('is-loading');
          elAdd.disabled = false;
          render();
        });
      });
    }

    render();
  }

  function initCaseFilters() {
    var grid = document.getElementById('caseGrid');
    var bar = document.getElementById('caseFilters');
    if (!grid || !bar) return;
    var note = document.getElementById('caseNote');
    var perShelf = parseInt(grid.getAttribute('data-all-per-shelf'), 10) || 0;
    var batch = parseInt(grid.getAttribute('data-load-batch'), 10) || 24;
    var eligible = note ? parseInt(note.getAttribute('data-case-eligible'), 10) || 0 : 0;
    var searchBox = document.getElementById('caseSearchInput');
    var searchClear = document.getElementById('caseSearchClear');
    var searchResults = document.getElementById('caseSearchResults');
    var loadMore = document.getElementById('caseLoadMore');
    var activeHandle = '';                              // '' means "All drinks"
    var activeLabel = 'All drinks';
    var activeTotal = eligible;

    /* Read fresh every time rather than cached once at init, since Load more and search both
       add cards after this function starts: a stale snapshot would leave them invisible to
       apply() the next time a shelf chip is clicked. */
    function cards() { return [].slice.call(grid.querySelectorAll('.case-card')); }

    function apply(handle, label, total) {
      activeHandle = handle; activeLabel = label; activeTotal = total;
      var shown = 0;
      cards().forEach(function (card) {
        var mine = card.getAttribute('data-case-shelf') === handle;
        var rank = parseInt(card.getAttribute('data-case-rank'), 10) || 0;
        var on = handle ? mine : rank < perShelf;
        card.hidden = !on;
        if (on) shown++;
      });
      updateNote(shown);
      updateLoadMore();
    }

    function updateNote(shown) {
      if (!note) return;
      note.textContent = activeHandle
        ? 'Showing ' + shown + ' of ' + activeTotal + ' in ' + activeLabel + '. Use search for a specific bottle.'
        : 'Showing ' + shown + ' of ' + eligible + ' eligible bottles, an even spread across '
          + bar.querySelectorAll('[data-case-filter]:not([data-case-filter=""])').length
          + ' shelves. Pick a shelf to see more of it, or use search for a specific bottle.';
    }

    bar.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-case-filter]');
      if (!chip) return;
      bar.querySelectorAll('[data-case-filter]').forEach(function (x) { x.classList.toggle('on', x === chip); });
      exitSearch();
      apply(chip.getAttribute('data-case-filter'), chip.textContent.trim(),
            parseInt(chip.getAttribute('data-case-total'), 10) || 0);
    });

    var shelfCache = {};                                

    function loadShelf(handle) {
      if (!shelfCache[handle]) shelfCache[handle] = { products: [], promise: null };
      var entry = shelfCache[handle];
      if (entry.promise) return entry.promise;

      function nextPage(page) {
        return j('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page)
          .then(function (data) {
            var got = data.products || [];
            entry.products = entry.products.concat(got);
            if (got.length < 250) return entry.products;
            return nextPage(page + 1);
          });
      }

      entry.promise = nextPage(1).catch(function (err) {
        entry.promise = null;                           // let a later attempt retry instead of sticking on a dead promise
        throw err;
      });
      return entry.promise;
    }

    function shownVariantIds() {
      var ids = {};
      grid.querySelectorAll('[data-case-add]').forEach(function (b) { ids[b.getAttribute('data-case-add')] = true; });
      return ids;
    }


    function cardNode(product, handle, rank) {
      var v = product.variants && product.variants[0];
      if (!v) return null;
      var img = (v.featured_image && v.featured_image.src) || (product.images[0] && product.images[0].src) || '';
      if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=700';
      var price = Math.round(parseFloat(v.price) * 100) || 0;
      var compareAt = v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
      var savePct = compareAt > price ? Math.round(((compareAt - price) / compareAt) * 100) : 0;

      var art = document.createElement('article');
      art.className = 'case-card';
      art.setAttribute('data-case-shelf', handle);
      art.setAttribute('data-case-rank', rank);

      var a = document.createElement('a');
      a.className = 'cc-media';
      a.href = '/products/' + product.handle;
      a.setAttribute('aria-label', product.title);
      if (img) {
        var im = document.createElement('img');
        im.src = img; im.alt = product.title; im.loading = 'lazy'; im.decoding = 'async';
        a.appendChild(im);
      }
      if (savePct > 0) {
        var tag = document.createElement('span');
        tag.className = 'tag tag-save';
        tag.textContent = 'Save ' + savePct + '%';
        a.appendChild(tag);
      }
      art.appendChild(a);

      var body = document.createElement('div');
      body.className = 'cc-body';
      var brand = document.createElement('div');
      brand.className = 'cc-brand';
      brand.textContent = product.vendor;
      var name = document.createElement('a');
      name.className = 'cc-name';
      name.href = '/products/' + product.handle;
      name.textContent = product.title;
      var meta = document.createElement('div');
      meta.className = 'cc-meta';
      var priceEl = document.createElement('span');
      priceEl.className = 'price';
      priceEl.textContent = LQ.moneyExact(price);
      meta.appendChild(priceEl);
      body.appendChild(brand); body.appendChild(name); body.appendChild(meta);
      art.appendChild(body);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn btn-amber btn-sm btn-block cc-add';
      btn.setAttribute('data-case-add', String(v.id));
      btn.setAttribute('data-case-name', product.title);
      btn.setAttribute('data-case-price', String(price));
      btn.setAttribute('data-case-img', img);
      btn.textContent = 'Add to case';
      art.appendChild(btn);

      return art;
    }

    function updateLoadMore() {
      if (!loadMore) return;
      if (!activeHandle) { loadMore.hidden = true; return; }      // "Pick a shelf to see more of it"
      var shownCount = cards().filter(function (c) {
        return c.getAttribute('data-case-shelf') === activeHandle && !c.hidden;
      }).length;
      loadMore.hidden = shownCount >= activeTotal;
    }

    if (loadMore) {
      loadMore.addEventListener('click', function () {
        if (!activeHandle) return;
        loadMore.disabled = true;
        loadMore.classList.add('is-loading');
        loadShelf(activeHandle).then(function (products) {
          var seen = shownVariantIds();
          var nextRank = cards().filter(function (c) { return c.getAttribute('data-case-shelf') === activeHandle; }).length;
          var added = 0;
          for (var i = 0; i < products.length && added < batch; i++) {
            var p = products[i];
            var v = p.variants && p.variants[0];
            if (!v || !v.available) continue;
            if (seen[String(v.id)]) continue;
            var node = cardNode(p, activeHandle, nextRank + added);
            if (!node) continue;
            grid.appendChild(node);
            seen[String(v.id)] = true;
            added++;
          }
          updateNote(cards().filter(function (c) {
            return c.getAttribute('data-case-shelf') === activeHandle && !c.hidden;
          }).length);
          updateLoadMore();
        }).catch(function () {
          LQ.Toast.show('Could not load more bottles. Please try again', 'cart');
        }).then(function () {
          loadMore.disabled = false;
          loadMore.classList.remove('is-loading');
        });
      });
    }

    var RESULT_CAP = 60;
    var searchTimer = null;

    function poolHandles() {
      return [].slice.call(bar.querySelectorAll('[data-case-filter]:not([data-case-filter=""])'))
        .map(function (b) { return b.getAttribute('data-case-filter'); });
    }

    function matches(product, q) {
      var hay = (product.title + ' ' + product.vendor).toLowerCase();
      return hay.indexOf(q) > -1;
    }

    function restoreGridView() {
      if (searchResults) { searchResults.hidden = true; searchResults.textContent = ''; }
      grid.hidden = false;
      bar.hidden = false;
      updateLoadMore();
      updateNote(cards().filter(function (c) { return !c.hidden; }).length);
    }
    
    function exitSearch() {
      if (searchTimer) { clearTimeout(searchTimer); searchTimer = null; }
      if (searchBox) searchBox.value = '';
      if (searchClear) searchClear.hidden = true;
      restoreGridView();
    }

    function runSearch(raw) {
      var q = raw.trim().toLowerCase();
      if (q.length < 2) { restoreGridView(); return; }
      if (searchClear) searchClear.hidden = false;
      if (!searchResults) return;

      var handles = activeHandle ? [activeHandle] : poolHandles();
      Promise.all(handles.map(loadShelf)).then(function (lists) {
        var seen = {};
        var found = [];
        lists.forEach(function (list, li) {
          list.forEach(function (p) {
            var v = p.variants && p.variants[0];
            if (!v || !v.available) return;
            if (seen[v.id]) return;
            if (!matches(p, q)) return;
            seen[v.id] = true;
            found.push({ product: p, handle: handles[li] });
          });
        });

        grid.hidden = true;
        bar.hidden = true;
        if (loadMore) loadMore.hidden = true;

        searchResults.textContent = '';
        found.slice(0, RESULT_CAP).forEach(function (f, i) {
          var node = cardNode(f.product, f.handle, i);
          if (node) searchResults.appendChild(node);
        });
        searchResults.hidden = false;

        if (note) {
          note.textContent = found.length === 0
            ? 'No bottles match "' + raw.trim() + '".'
            : 'Showing ' + Math.min(found.length, RESULT_CAP) + ' of ' + found.length + ' matching "' + raw.trim() + '"'
              + (found.length > RESULT_CAP ? ' — refine your search to narrow it down.' : '.');
        }
      }).catch(function () {
        LQ.Toast.show('Search could not load right now. Please try again', 'cart');
      });
    }

    if (searchBox) {
      searchBox.addEventListener('input', function () {
        if (searchClear) searchClear.hidden = searchBox.value.length === 0;
        if (searchTimer) clearTimeout(searchTimer);
        var val = searchBox.value;
        searchTimer = setTimeout(function () { runSearch(val); }, 300);
      });
    }
    if (searchClear) {
      searchClear.addEventListener('click', function () {
        exitSearch();
        if (searchBox) searchBox.focus();
      });
    }

    updateLoadMore();
  }


  function initWishlist() {
    var root = document.querySelector('[data-wish-root]');
    if (!root) return;
    var grid = document.getElementById('wishGrid');
    var empty = document.getElementById('wishEmpty');
    var loading = document.getElementById('wishLoading');
    var handles = LQ.Wish.list().filter(Boolean);
    if (!handles.length) return;                 


    if (empty) empty.hidden = true;
    if (loading) loading.hidden = false;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?section_id=wish-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html || html.indexOf('pcard') === -1) return '';
          /* the API wraps the response in the section's own div, so unwrap it */
          var box = document.createElement('div');
          box.innerHTML = html;
          var card = box.querySelector('.pcard');
          return card ? card.outerHTML : '';
        })
        .catch(function () { return ''; });
    })).then(function (parts) {
      var good = parts.filter(Boolean);
      if (loading) loading.hidden = true;
      if (!good.length) {                                
        if (empty) empty.hidden = false;
        return;
      }
      grid.innerHTML = good.join('');
      grid.hidden = false;
      LQ.Wish.paint(grid);
      Cart.bind && Cart.bind(grid);
    });
  }


  var promoBound = false;
  function initCartPromo() {
    var input = document.getElementById('promo');
    if (!input) return;

    function apply() {
      var input = document.getElementById('promo');       
      var msg = document.getElementById('promoMsg');
      var code = (input && input.value || '').trim();
 
      if (!code) {
        
        promoNotice = { text: 'Enter a promo code first.', cls: 'err' };
        paintPromoMsg();
        if (input) input.focus();
        return;
      }

      try { sessionStorage.setItem('liq_promo_try', code); } catch (e) {}

      var btn = document.querySelector('[data-promo-apply]');
      if (btn) { btn.disabled = true; btn.textContent = 'Applying…'; }
      promoNotice = null;
      if (msg) { msg.textContent = ''; msg.className = ''; }
      
      window.location.href = '/discount/' + encodeURIComponent(code) +
        '?redirect=' + encodeURIComponent(window.location.pathname);
    }

    
    if (!promoBound) {
      promoBound = true;
      document.addEventListener('click', function (e) {
        var t = e.target && e.target.closest && e.target.closest('[data-promo-apply]');
        if (t) { e.preventDefault(); apply(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var t = e.target && e.target.closest && e.target.closest('#promo');
        if (t) { e.preventDefault(); apply(); }
      });
    }
    readPromoNotice();
    paintPromoMsg();
  }

  var promoNotice = null;   

  function readPromoNotice() {
    var tried = null;
    try { tried = sessionStorage.getItem('liq_promo_try'); } catch (e) {}
    if (!tried) return;
    try { sessionStorage.removeItem('liq_promo_try'); } catch (e) {}
    var applied = document.querySelectorAll('.summary .disc-amt').length > 0;
    promoNotice = applied
      ? { text: 'Promo code applied.', cls: 'ok' }

      : { text: 'We couldn’t apply “' + tried + '”. Check the code, or it may not apply to these items.', cls: 'err' };
  }

  function paintPromoMsg() {
    var msg = document.getElementById('promoMsg');
    if (!msg || !promoNotice) return;
    msg.textContent = promoNotice.text;
    msg.className = promoNotice.cls;
  }
  
  document.addEventListener('cart:rendered', function () { paintPromoMsg(); });


  var noteBound = false;
  var noteTimer = null;
  function saveCartNote(value) {
    Cart.note(value).catch(function (e) {
      if (window.console) console.warn('cart note save failed:', e.message);
    });
  }
  function initCartNote() {
    if (noteBound) return;
    noteBound = true;
    document.addEventListener('input', function (e) {
      var t = e.target && e.target.closest && e.target.closest('#cartNote');
      if (!t) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () { saveCartNote(t.value); }, 600);
    });
    document.addEventListener('focusout', function (e) {
      var t = e.target && e.target.closest && e.target.closest('#cartNote');
      if (!t) return;
      clearTimeout(noteTimer);
      saveCartNote(t.value);
    });
  }

  var SHIP_ZIP_KEY = 'liq_ship_zip';
  var SHIP_PROVINCE_KEY = 'liq_ship_province';
  var shipBound = false;

  function setShipMsg(text, cls) {
    var msg = document.getElementById('shipMsg');
    if (!msg) return;
    msg.textContent = text || '';
    msg.className = cls || '';
  }

  // rate.price from /cart/shipping_rates.json is a decimal-Rand string ("65.00"), not
  // cents like every other cart figure here - convert once, here.
  function applyShippingResult(rate) {
    var amt = document.getElementById('deliveryAmt');
    var tot = document.getElementById('grandTot');
    var pf = document.getElementById('pfLine');
    if (!amt || !Cart.state) return;
    var rateCents = Math.round(parseFloat(rate.price) * 100);
    var grand = Cart.state.total_price + rateCents;
    amt.textContent = rateCents === 0 ? 'FREE' : LQ.money(rateCents);
    if (tot) tot.textContent = LQ.money(grand);
    if (pf) pf.textContent = 'or 4× ' + LQ.money(Math.round(grand / 4)) + ' interest-free with Payflex';
  }

  function checkShipping(zip, province, opts) {
    opts = opts || {};
    zip = (zip || '').trim();
    province = (province || '').trim();
    if (!zip || !province) return;
    var btn = document.querySelector('[data-ship-check]');
    if (btn && !opts.silent) { btn.disabled = true; btn.textContent = 'Checking…'; }
    Cart.shippingRates(zip, province).then(function (rates) {
      if (btn) { btn.disabled = false; btn.textContent = 'Check'; }
      if (!rates.length) {
        setShipMsg('No delivery rate found for that address.', 'err');
        return;
      }
      var cheapest = rates[0];
      for (var i = 1; i < rates.length; i++) {
        if (parseFloat(rates[i].price) < parseFloat(cheapest.price)) cheapest = rates[i];
      }
      applyShippingResult(cheapest);
      try {
        localStorage.setItem(SHIP_ZIP_KEY, zip);
        localStorage.setItem(SHIP_PROVINCE_KEY, province);
      } catch (e) {}
      var cents = Math.round(parseFloat(cheapest.price) * 100);
      setShipMsg('Delivery to ' + zip + ': ' + (cents === 0 ? 'FREE' : LQ.money(cents)), 'ok');
    }).catch(function (e) {
      if (btn) { btn.disabled = false; btn.textContent = 'Check'; }
      if (window.console) console.warn('shipping rate lookup failed:', e.message);
      if (!opts.silent) setShipMsg('Could not check delivery for that address.', 'err');
    });
  }

  function initCartShipping() {
    var input = document.getElementById('shipZip');
    var provinceSel = document.getElementById('shipProvince');
    if (!input || !provinceSel) return;

    if (!shipBound) {
      shipBound = true;
      document.addEventListener('click', function (e) {
        var t = e.target && e.target.closest && e.target.closest('[data-ship-check]');
        if (!t) return;
        e.preventDefault();
        var z = document.getElementById('shipZip');
        var p = document.getElementById('shipProvince');
        if (!(p && p.value)) { setShipMsg('Choose your province too.', 'err'); return; }
        checkShipping(z && z.value, p.value);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        var t = e.target && e.target.closest && e.target.closest('#shipZip');
        if (!t) return;
        e.preventDefault();
        var p = document.getElementById('shipProvince');
        if (!(p && p.value)) { setShipMsg('Choose your province too.', 'err'); return; }
        checkShipping(t.value, p.value);
      });
      document.addEventListener('cart:rendered', function () {
        var z = null, p = null;
        try {
          z = localStorage.getItem(SHIP_ZIP_KEY);
          p = localStorage.getItem(SHIP_PROVINCE_KEY);
        } catch (e) {}
        var freshZip = document.getElementById('shipZip');
        var freshProvince = document.getElementById('shipProvince');
        if (freshZip && z) freshZip.value = z;
        if (freshProvince && p) freshProvince.value = p;
        if (z && p) checkShipping(z, p, { silent: true });
      });
    }

    var savedZip = null, savedProvince = null;
    try {
      savedZip = localStorage.getItem(SHIP_ZIP_KEY);
      savedProvince = localStorage.getItem(SHIP_PROVINCE_KEY);
    } catch (e) {}
    var startZip = savedZip || input.value;
    var startProvince = savedProvince || provinceSel.value;
    if (startZip && startProvince) checkShipping(startZip, startProvince, { silent: true });
  }


  function initPDP() {
    var root = document.querySelector('.pdp');
    if (!root) return;

    /* --- gallery thumbs --- */
    var main = document.getElementById('mainImg');
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-pdp-thumb');
        if (main && src) main.src = src;
        document.querySelectorAll('[data-pdp-thumb]').forEach(function (b) { b.classList.toggle('on', b === btn); });
      });
    });

    var qty = document.getElementById('qtyV');
    document.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qty) return;
        var d = parseInt(btn.getAttribute('data-qty'), 10) || 0;
        var next = Math.max(1, (parseInt(qty.value, 10) || 1) + d);
        qty.value = next;
      });
    });

    var tabs = document.querySelectorAll('[data-pdp-tab]');
    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-pdp-tab');
        tabs.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('on', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        document.querySelectorAll('.tabpane').forEach(function (pane) {
          var on = pane.id === id;
          pane.classList.toggle('on', on);
          pane.hidden = !on;
        });
      });
    });

    var data = {};
    try { data = JSON.parse((document.getElementById('pdpData') || {}).textContent || '{}'); } catch (e) {}
    function pdpAnswer(q) {
      var s = String(q || '').toLowerCase();
      if (/genuine|authentic|real|original|fake/.test(s)) return 'Yes. This is 100% genuine, sealed stock from licensed suppliers.';

      if (/deliver|ship|how long|when/.test(s)) return 'Same-day in major metros (order before 11am), or 1-3 working days nationwide.' + (LQ.FREE_THRESHOLD === null ? '' : ' Free delivery over ' + LQ.money(LQ.FREE_THRESHOLD * 100) + '.');
      if (/price|cheap|match|discount/.test(s)) return 'It’s ' + LQ.money(data.price) + '. Found it cheaper at another SA retailer? We’ll match it. See our best-price promise.';
      if (/payflex|instal|credit|split|pay/.test(s)) return 'You can split into 4 interest-free payments of ' + LQ.money(Math.round(data.price / 4)) + ' with Payflex or PayJustNow.';
      if (/warrant|return|refund/.test(s)) return 'Unopened items can be returned within 14 days. Damaged-on-delivery items are replaced free.';
      if (/stock|available|in stock/.test(s)) {
        return data.avail === 'low' ? 'Low stock, order soon.'
          : data.avail === 'supplier' ? 'In stock with supplier, 2-4 days.'
          : data.avail === 'out' ? 'This one is sold out at the moment.' : 'In stock, ships today.';
      }

      if (/size|ml|volume|how much/.test(s)) {
        return data.vol ? ('This is the ' + data.vol + ' size.')
          : 'The size for this listing isn’t published. Our barman (chat, bottom-right) can confirm it, or call 076 061 5783.';
      }
      if (/box|gift|wrap/.test(s)) return 'We can gift-wrap this at checkout: add a gift box and a personal message.';
      return 'This one needs a person. Our barman (chat, bottom-right) can help, or call 076 061 5783.';
    }
    var askBtn = document.querySelector('[data-pdp-ask]');
    var askIn = document.getElementById('askInput');
    var askAns = document.getElementById('askAns');
    function doAsk() {
      if (!askIn || !askAns) return;
      var val = askIn.value.trim();
      if (!val) return;

      askAns.textContent = '';
      var lead = document.createElement('b');

      lead.textContent = 'Quick answer:';
      askAns.appendChild(lead);
      askAns.appendChild(document.createTextNode(' ' + pdpAnswer(val)));
      askAns.classList.add('show');
      askIn.value = '';
    }
    if (askBtn) askBtn.addEventListener('click', doAsk);
    if (askIn) askIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); doAsk(); } });

    var bar = document.getElementById('pdpSticky');
    var buy = document.querySelector('.pdp-buy');
    if (bar && buy) {
      var ticking = false;
      var update = function () {
        var r = buy.getBoundingClientRect();
        var show = r.bottom < 8 && window.innerWidth <= 760;
        bar.classList.toggle('show', show);
        document.body.classList.toggle('pdp-bar-on', show);
        LQ._setInert(bar, !show);
        ticking = false;
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', onScroll, { passive: true });
      update();
    }
  }


  LQ.openMini = function () { LQ.Drawer.open(); };
  LQ.closeMini = function () { LQ.Drawer.close(); };
  LQ.openNav = function () { LQ.Nav.open(); };
  LQ.closeNav = function () { LQ.Nav.close(); };
  LQ.openSearch = function (q) { LQ.Search.open(q); };
  LQ.closeSearch = function () { LQ.Search.close(); };
  LQ._runSearch = function (q) { LQ.Search.run(q); };
  LQ.toggleWish = function (id, btn) { return LQ.Wish.toggle(id, btn); };

  function initMnavAcc() {
    var host = document.getElementById("mnav");
    if (!host) return;
    host.addEventListener("click", function (e) {
      var h = e.target.closest("[data-acc-toggle]");
      if (!h) return;
      var sec = h.closest(".acc");
      if (!sec) return;
      var open = sec.classList.toggle("open");
      h.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  function initRelatedShuffle() {
    document.querySelectorAll(".js-shuffle").forEach(function (grid) {
      var pick = parseInt(grid.getAttribute("data-shuffle-pick"), 10) || 5;
      var cards = Array.prototype.slice.call(grid.children);
      if (cards.length > pick) {
        for (var i = cards.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = cards[i];
          cards[i] = cards[j];
          cards[j] = t;
        }
        cards.forEach(function (card, idx) {
          card.hidden = idx >= pick;
        });
      }
      grid.classList.add("js-ready");
    });
  }

  function boot() {

    ["mnav", "miniCart"].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && !el.classList.contains("open")) setInert(el, true);
    });
    initMnavAcc();
    Cart.refresh();
    LQ.Wish.paint();
    ageGate();
    offerModal();
    stickyState();
    initPLP();
    initPDP();
    initRelatedShuffle();
    initCartPromo();
    initCartNote();
    initCartShipping();
    initWishlist();
    initCase();
    initCaseFilters();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
